<template>
   <table-column :table-id="tableId"></table-column>
</template>

<style scoped>

</style>

<script>
  import Column from "./column.ts";
  export default Column;
</script>